// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductBreadCrumbs_container__lqkUu","hiddenMobile":"ProductBreadCrumbs_hiddenMobile__V3cjs","hiddenDesktop":"ProductBreadCrumbs_hiddenDesktop__hBklt"};